import api from './api';
import model from './model';

export default {
  api,
  model,
};
